import React, {
  FC,
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useState,
} from "react"
import { areaLv } from "@api/report"
import { observer, inject } from "mobx-react"
import moment from "moment"
import Env from "@util/env"
import useRadiusChanger from "../../RadiusChanger"

function getRandomOffset(base, rand) {
  return base + (Math.random() > 0.5 ? 1 : -1) * Math.random() * rand
}
/**
 * LayerAreaHeat
 * @param param0
 */
const LayerAreaHeat: FC<any> = ({ map, visible, store }) => {
  const [total, setTotal] = useState<any>()
  const [data, setData] = useState<any>()
  const [heatMap, setHeatMap] = useState<any>()
  const refTimer = useRef<NodeJS.Timeout | null>(null)
  const { value: radius } = useRadiusChanger(
    "__ISLAND_HEAR_RADIUS__",
    ["ctrl.=", "ctrl.+"],
    ["ctrl.-", "ctrl._"],
    40,
    100,
    1,
    1
  )
  const [week, day, timeBefor] = useMemo(() => {
    let week = store.date.isoWeek() % 2
    let day = store.date.isoWeekday()
    let timeBefor = 3000
    if (day >= 6) {
      timeBefor = timeBefor / 5
    }
    return [week, day, timeBefor]
  }, [store.date])
  // 动态获取当前热力数据
  const getCurrentData = useCallback(
    (totalList, timeBefor) => {
      let t = moment().unix()
      let list = totalList.filter(
        (item) => item[2] <= t && item[2] >= t - timeBefor
      )
      let rand = 0.000005
      list = list.map((coord) => {
        return [
          getRandomOffset(coord[0], rand),
          getRandomOffset(coord[1], rand / 2),
          coord[2],
        ]
      })
      setData(list)
      if (refTimer.current) {
        clearTimeout(refTimer.current)
      }
      refTimer.current = setTimeout(() => {
        getCurrentData(totalList, timeBefor)
      }, 10000)
    },
    [setData, refTimer]
  )
  useEffect(() => {
    if (total) {
      getCurrentData(total, timeBefor)
    }
    return () => {
      refTimer.current && clearTimeout(refTimer.current)
    }
  }, [total, timeBefor])
  // 获取热力数据
  const getData = useCallback(async () => {
    let res = await areaLv()
    setTotal(res)
  }, [])

  useMemo(() => {
    let heatData = []
    let max = 2
    if (!visible) {
      heatMap && heatMap.hide()
      return
    }

    if (data && data.length) {
      for (let k in data) {
        heatData.push({
          lng: data[k][0],
          lat: data[k][1],
          count: 1,
        })
        max = Math.max(max, 1)
      }
    }
    if (heatMap) {
      heatMap.show()
      heatMap.setDataSet({
        data: heatData,
        max: max,
      })
    }
  }, [data, heatMap, visible])
  useMemo(() => {
    if (heatMap && radius) {
      heatMap.setOptions({
        radius: radius * Env.getScale(),
      })
    }
  }, [heatMap, radius])
  useEffect(() => {
    var heatmap
    map &&
      map.plugin(["AMap.Heatmap"], function () {
        //初始化heatmap对象
        heatmap = new window.AMap.Heatmap(map, {
          radius: radius * Env.getScale(), //给定半径
          opacity: [0, 0.7],
          zIndex: 120,
          zoom: [10, 20],
          // gradient: {
          //   0.25: "#2993f2",
          //   0.5: "#00a347",
          //   0.75: "#98d51c",
          //   1: "#c5560b",
          // },
        })
        setHeatMap(heatmap)
      })
    // var imageLayer = new window.AMap.ImageLayer({
    //   url: require("@/assets/photo/park.jpg"),
    //   bounds: new window.AMap.Bounds(
    //     [121.607271, 31.184215],
    //     [121.612035, 31.187209]
    //   ),
    //   zooms: [15, 20],
    // })
    // imageLayer.setMap(map)
    // getData()
    return () => {
      try {
        heatmap && heatmap.setMap(null)
      } catch (error) {}
    }
  }, [map])
  useEffect(() => {
    getData()
  }, [getData])
  return null
}

export default inject("store")(observer(LayerAreaHeat))
